/**
 * Do ktorého kroku importného sprievodcu patrí ktorý nález.
 *
 * Do KOLA 114 sa **všetky** nálezy kreslili v prvom kroku (Dielce), kde
 * sa delia sendviče. User na to narazil hneď: *„toto mi vyskakuje hneď
 * ako prvé okno pri delení materiálu, ani materiál som nevybral a nie
 * ešte hrany"* — a mal pravdu, že hlásenie o hrane tam nemá čo robiť.
 *
 * Appka pritom nehádala: `_oprava_hrany` číta dekor priamo z exportu
 * (`W960`) a pozrie sa naň do cenníka, takže vie aj bez priradenia. Ale
 * vedieť to a **ukázať to v kroku, kde sa s tým nedá nič spraviť**, sú
 * dve rôzne veci.
 */

/** Kroky sprievodcu — poradie je poradie na páse. */
export type Krok = "dielce" | "materialy" | "kovania";

/**
 * Druh nálezu → krok, v ktorom sa s ním dá niečo spraviť.
 *
 * Zrkadlo konštánt `OPRAVA_*` v
 * `backend/src/tandem_budget/services/topsolid_import.py`; paritu stráži
 * test, ktorý ten zdroják číta — bez neho by nový druh nálezu ticho
 * vypadol z kroku a človek by ho našiel až v súhrne.
 */
export const KROK_NALEZU: Record<string, Krok> = {
  // rozmer, operácia a zaradenie dielca — to všetko je krok „Dielce"
  bez_hrubky: "dielce",
  neznama_operacia: "dielce",
  zle_zaradenie: "dielce",
  nadmiera_nesedi: "dielce",
  // Ohýbaný dielec bez Rozvinu (KOLO 216) — chyba rozmeru dielca, riadok
  // materiálu sa pustí len ako Nenahrávať
  nemozna_hrubka: "dielce",
  // Skrinka nastavená v TopSolide ako Zostava namiesto Obsah (KOLO 219) —
  // chýbajú dielce, tak to má byť vidieť hneď v prvom kroku
  zostava_bez_obsahu: "dielce",
  // materiál a hrany sa priraďujú v jednom kroku, lebo dekor hrany
  // vychádza z priradenej dosky
  bez_materialu: "materialy",
  hrana_ina_hrubka: "materialy",
  hrana_ina_sirka: "materialy",
};

/**
 * Nálezy pre daný krok.
 *
 * **Neznámy druh sa nezahodí** — spadne do posledného kroku, kde je aj
 * úplný zoznam. Nález, ktorý zmizol, je horší než nález na nesprávnom
 * mieste: backend môže pridať druh a frontend o ňom ešte nevie.
 */
export function opravyPreKrok<T extends { druh: string }>(
  opravy: T[],
  krok: Krok,
): T[] {
  return opravy.filter((o) => (KROK_NALEZU[o.druh] ?? "kovania") === krok);
}
